import { ProConfigProvider } from '@ant-design/pro-components';
import { useTheme } from '@zhiyue/core';
import { ConfigProvider } from 'antd';
import * as React from 'react';
import { TablePreferenceProvider } from '@/components/AppTable';
import { inlineNoticeConfig } from './inlineNotice';
import { getShellTheme } from './shellTheme';

export default function ShellThemeBoundary({
  children,
  scope = 'shell',
}: {
  children: import('react').ReactNode;
  scope?: string;
}) {
  const { navTheme } = useTheme();
  return (
    <ConfigProvider
      theme={getShellTheme(navTheme, scope)}
      alert={inlineNoticeConfig}
    >
      <ProConfigProvider dark={navTheme === 'realDark'}>
        <TablePreferenceProvider>{children}</TablePreferenceProvider>
      </ProConfigProvider>
    </ConfigProvider>
  );
}
